import type { FC } from 'react';
import { Card, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { PortfolioRowViewModel } from '../../OrganizationManagerDashboardPage.types';
import { EvimoTable } from '~/app/components/common/EvimoTable/EvimoTable';

const { Title } = Typography;

export interface PropertyPortfolioTableProps {
  title: string;
  columns: ColumnsType<PortfolioRowViewModel>;
  rows: PortfolioRowViewModel[];
}

export const PropertyPortfolioTable: FC<PropertyPortfolioTableProps> = ({
  title,
  columns,
  rows,
}) => {
  return (
    <Card className="om-section-card" styles={{ body: { padding: 24 } }}>
      <Title
        level={5}
        className="ds-section-header"
        style={{ margin: '0 0 16px' }}
      >
        {title}
      </Title>
      <EvimoTable
        className="ds-table om-portfolio-table"
        columns={columns}
        dataSource={rows}
        rowKey="id"
        pagination={false}
        size="middle"
      />
    </Card>
  );
};
